import incomeReconciliationAPI from '@/api/incomeReconciliation';
import staticDataAPI from '@/api/static';

export default {
  namespace: true,

  state: () => ({
    currentStatement: null,
    // The month (statement) uuid most recently requested, so stale responses can be ignored.
    requestedStatementUuid: null,
    categoryOptions: [],
  }),

  getters: {
    currentStatementUuid: (state) => {
      return state.currentStatement?.uuid;
    },
    statementStart: (state) => {
      return state.currentStatement?.start_date;
    },
    statementEnd: (state) => {
      return state.currentStatement?.end_date;
    },
  },

  mutations: {
    SET_STATEMENT(state, statement) {
      state.currentStatement = statement;
    },
    RESET_STATEMENT(state) {
      state.currentStatement = null;
      state.requestedStatementUuid = null;
    },
    SET_REQUESTED_STATEMENT_UUID(state, uuid) {
      state.requestedStatementUuid = uuid;
    },
    SET_CHARGE_CATEGORIES(state, categories) {
      state.categoryOptions = categories;
    },
  },

  actions: {
    getStatement({ state, commit }, uuid) {
      commit('SET_REQUESTED_STATEMENT_UUID', uuid);

      return incomeReconciliationAPI
        .getStatement(uuid)
        .then((rsp) => {
          // Ignore the response if the month was reset or another month was requested in the meantime.
          if (state.requestedStatementUuid !== uuid) {
            return;
          }

          commit('SET_STATEMENT', rsp.data.data);
        })
        .catch((err) => {
          throw err;
        });
    },

    resetStatement({ commit }) {
      commit('RESET_STATEMENT');
    },

    getChargeCategories({ state, commit }) {
      if (state.categoryOptions.length > 0) {
        return;
      }

      return staticDataAPI
        .getChargeCategories()
        .then((rsp) => {
          commit('SET_CHARGE_CATEGORIES', rsp.data.data);
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
